export * from './use-swr';
import { default as useSWR } from './use-swr';
export { useSWRInfinite } from './use-swr-infinite';
export { cache } from './config';
export default useSWR;



//////////////////
// WEBPACK FOOTER
// ./node_modules/swr/esm/index.js
// module id = 6
// module chunks = 0 1 2 3